import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActionDGAGEnum } from 'src/app/constantes/action-dgag.enum';
import { CybermetrieEnum } from '../../constantes/cybermetrie.enum';
import { CybermetrieCoordonneesService } from '@services/cybermetrie/cybermetrie.service';
import { ContexteModificationEnum } from 'src/app/constantes/contexte-modification.enum';
import { SystemeEntiteEnum } from 'src/app/constantes/systeme-entite.enum';

@Component({
  selector: 'app-page-confirmation-adresse',
  templateUrl: './page-confirmation-adresse.component.html',
  standalone: false,
})
export class PageConfirmationAdresseComponent implements OnInit {
  reponseDGAG?: ActionDGAGEnum;
  cybermetrieLabel = CybermetrieEnum.LABEL_MODIFIER_ADRESSE;
  estDGAGApparie!: boolean;
  succesPartiel = false;
  succesPartielDGAG = false;

  private readonly router = inject(Router);
  private readonly cybermetrieCoordonneesService = inject(CybermetrieCoordonneesService);

  ngOnInit(): void {
    const navigationState = this.router.lastSuccessfulNavigation?.extras.state as {
      DGAG?: ActionDGAGEnum;
      estDGAGApparie?: boolean;
    };
    this.reponseDGAG = navigationState?.DGAG ?? ActionDGAGEnum.AUCUNE_ACTION;
    this.estDGAGApparie = navigationState?.estDGAGApparie ?? false;
  }

  get afficherAppelDGAG(): boolean {
    return this.succesPartielDGAG || this.reponseDGAG === ActionDGAGEnum.APPELER;
  }

  get afficherRecevoirAppel(): boolean {
    return !this.succesPartielDGAG && this.reponseDGAG === ActionDGAGEnum.RECEVOIR_APPEL;
  }

  get afficherDGAG(): boolean {
    return this.reponseDGAG !== ActionDGAGEnum.AUCUNE_ACTION;
  }

  onSystemesEnErreurChange(systemesEnErreur: SystemeEntiteEnum[]): void {
    this.succesPartiel = systemesEnErreur.length > 0;
    this.succesPartielDGAG = systemesEnErreur.includes(SystemeEntiteEnum.DGAG);
    this.envoyerCybermetrie();
  }

  envoyerCybermetrie(): void {
    this.cybermetrieCoordonneesService.transactionComplete(
      this.cybermetrieLabel,
      ContexteModificationEnum.ADRESSE,
      this.getCybermetrieTypeConfirmation(),
      this.estDGAGApparie
        ? CybermetrieEnum.EXTRA_ATTRIBUT_DGAG_APPARIE
        : CybermetrieEnum.EXTRA_ATTRIBUT_DGAG_NON_APPARIE,
    );
  }

  getCybermetrieTypeConfirmation(): string {
    if (this.reponseDGAG === ActionDGAGEnum.RECEVOIR_APPEL) {
      if (this.succesPartielDGAG) {
        return CybermetrieEnum.EXTRA_ATTRIBUT_PARTIEL_APPEL_REQUIS;
      }

      return this.succesPartiel
        ? CybermetrieEnum.EXTRA_ATTRIBUT_PARTIEL_APPEL_PLANIFIE
        : CybermetrieEnum.EXTRA_ATTRIBUT_APPEL_PLANIFIE;
    }

    if (this.reponseDGAG === ActionDGAGEnum.APPELER) {
      return this.succesPartiel
        ? CybermetrieEnum.EXTRA_ATTRIBUT_PARTIEL_APPEL_REQUIS
        : CybermetrieEnum.EXTRA_ATTRIBUT_APPEL_REQUIS;
    }

    return this.succesPartiel
      ? CybermetrieEnum.EXTRA_ATTRIBUT_PARTIEL
      : CybermetrieEnum.EXTRA_ATTRIBUT_CONFIRME;
  }
}
